import {
  Box,
  Grid,
  Typography,
  Paper,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";
import RequiredLabel from "components/RequiredLabel";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function SpecialPrograms() {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Box>
      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mt: 1 }}>
        <Box backgroundColor="divider" sx={{ p: 2, borderTopLeftRadius: 8, borderTopRightRadius: 8, }}>
          <Typography variant="h6">
            {t("Special Programs")}
          </Typography>
        </Box>
        <Grid container spacing={2} p={2}>
          <Grid item xs={12}>
            <FormControl component="fieldset">
              <Typography sx={{ mb: 1 }}><RequiredLabel>{t("Has your child been evaluated for and/or participated in a Gifted & Talented Program?")}</RequiredLabel></Typography>
              <Controller
                name="giftedProgram"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <RadioGroup row {...field}>
                      <FormControlLabel value="yes" control={<Radio />} label={t("Yes")} />
                      <FormControlLabel value="no" control={<Radio />} label={t("No")} />
                    </RadioGroup>
                    {fieldState.error && (
                      <FormHelperText sx={{ color: 'error.main' }}>{fieldState.error.message}</FormHelperText>
                    )}
                  </>
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl component="fieldset">
              <Typography sx={{ mb: 1 }}><RequiredLabel>{t("Did your child receive Special Education services from the previous school?")}</RequiredLabel></Typography>
              <Controller
                name="specialEducation"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <RadioGroup row {...field}>
                      <FormControlLabel value="yes" control={<Radio />} label={t("Yes")} />
                      <FormControlLabel value="no" control={<Radio />} label={t("No")} />
                    </RadioGroup>
                    {fieldState.error && (
                      <FormHelperText sx={{ color: 'error.main' }}>{fieldState.error.message}</FormHelperText>
                    )}
                  </>
                )}
              />
            </FormControl>
          </Grid>

        </Grid>
      </Paper>
    </Box>
  );
}
